import axios, { AxiosPromise } from 'axios'
import { api } from '@components/LeavePopup/constants'
import { IVideoResponse } from '@components/VideoPlayer/types'

export const RequestApi = {
  getVideoLink: (code: string): AxiosPromise<IVideoResponse> =>
    axios.get(api.video, {
      params: { code },
    }),
} as const
